<!-- 获取停车场车主信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { parkCode: "2KNTYVWC", pageNumber: "1", pageSize: "1" },
            responseCode: {"data":{"carOwnerList":[{"carList":[{"addBy":"admin","addTime":"20161208112345","carLicenseNumber":"粤Z6751港","carOwnType":0,"carSeq":1,"customerSeq":1,"similarPlates":""},{"addBy":"ERP","addTime":"20170907115641","carColor":0,"carLicenseNumber":"湘B12345","carLicenseType":0,"carLogo":0,"carModel":"0","carOwnType":0,"carSeq":237,"carSizeType":0,"carType":0,"customerSeq":1,"similarPlates":""},{"addBy":"ERP","addTime":"20170907115641","carColor":0,"carLicenseNumber":"湘B12346","carLicenseType":0,"carLogo":0,"carModel":"0","carOwnType":0,"carSeq":238,"carSizeType":0,"carType":0,"customerSeq":1,"similarPlates":""}],"carNumber":3,"customerName":"老张","customerRole":0,"customerSeq":1,"customerSex":2,"customerStatus":1,"customerTelphone":"13813631459","isDeleted":false}],"currCount":1,"parkCode":"2KNTYVWC","total":178},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车场车主信息",
                t_url: this.commonUrls.test+"getCarOwnerInfo",
                p_url: this.commonUrls.prod+"getCarOwnerInfo",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'customerId', info2: '否', info3: 'String', info4: '车主ID，由外部平台生成的唯一编号' },
                        { info1: 'customerSeq', info2: '否', info3: 'int', info4: '车主在vems的递增序列号' },
                        { info1: 'customerName', info2: '否', info3: 'String', info4: '车主名' },
                        { info1: 'customerTelphone', info2: '否', info3: 'String', info4: '车主电话' },
                        { info1: 'carLicenseNumber', info2: '否', info3: 'String', info4: '车牌号' },
                        { info1: 'pageNumber', info2: '是', info3: 'int', info4: '页号' },
                        { info1: 'pageSize', info2: '是', info3: 'int', info4: '每页大小' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'carOwnerList', info2: '是', info3: 'JSONArray', info4: '车主列表' }
                        ]
                },{
                    titleName: 'carOwnerList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'customerId', info2: '是', info3: 'String', info4: '车主ID，由外部平台生成的唯一编号' },
                        { info1: 'customerSeq', info2: '是', info3: 'int', info4: '车主在vems的递增序列号' },
                        { info1: 'customerName', info2: '是', info3: 'String', info4: '车主名' },
                        { info1: 'customerSex', info2: '是', info3: 'int', info4: '车主性别，0:男 1：女 2：未知' },
                        { info1: 'customerTelphone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'customerRole', info2: '是', info3: 'int', info4: 'VIP客户角色，0无角色，用于扩充用户角色使用' },
                        { info1: 'carNumber', info2: '是', info3: 'int', info4: 'VIP客户拥有的VIP车辆数量' },
                        { info1: 'carportNumber', info2: '是', info3: 'int', info4: 'VIP拥有的车位数量' },
                        { info1: 'customerCompany', info2: '是', info3: 'String', info4: '公司' },
                        { info1: 'customerDepartment', info2: '是', info3: 'String', info4: '部门' },
                        { info1: 'customerAddress', info2: '是', info3: 'String', info4: '地址' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'remark1', info2: '是', info3: 'String', info4: '备注1' },
                        { info1: 'remark2', info2: '是', info3: 'String', info4: '备注2' },
                        { info1: 'remark3', info2: '是', info3: 'String', info4: '备注3' },
                        { info1: 'identityCardNumber', info2: '是', info3: 'String', info4: '身份证号码' },
                        { info1: 'customerRoomNumber', info2: '是', info3: 'String', info4: '房间号' },
                        { info1: 'customerStatus', info2: '是', info3: 'int', info4: '0未启用，1启用，2禁用' },
                        { info1: 'isDeleted', info2: '是', info3: 'boolean', info4: '是否逻辑删除，0未删除，1删除' },
                        { info1: 'carList', info2: '是', info3: 'JSONArray', info4: '车辆列表' }
                        ]
                },{
                    titleName: 'carList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'customerId', info2: '是', info3: 'String', info4: '车主ID，由外部平台生成的唯一编号' },
                        { info1: 'customerSeq', info2: '是', info3: 'int', info4: '车主在vems的递增序列号' },
                        { info1: 'carSeq', info2: '是', info3: 'int', info4: '车辆在vems的递增序列号' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'carLicenseColor', info2: '是', info3: 'int', info4: '车牌颜色' },
                        { info1: 'carLicenseType', info2: '是', info3: 'int', info4: '车牌类型' },
                        { info1: 'carColor', info2: '是', info3: 'int', info4: '车辆颜色' },
                        { info1: 'carLogo', info2: '是', info3: 'int', info4: '车辆品牌' },
                        { info1: 'carModel', info2: '是', info3: 'String', info4: '品牌型号' },
                        { info1: 'carFullPicture', info2: '是', info3: 'String', info4: '车辆图片' },
                        { info1: 'carType', info2: '是', info3: 'int', info4: '车辆类型' },
                        { info1: 'carOwnType', info2: '是', info3: 'int', info4: '车归属类型，0未知，1公车，2私车' },
                        { info1: 'addTime', info2: '是', info3: 'String', info4: '添加时间，yyyyMMddHHmmss' },
                        { info1: 'addBy', info2: '是', info3: 'String', info4: '添加操作人' },
                        { info1: 'carSizeType', info2: '是', info3: 'int', info4: '车辆大小类型，0未知，1小车，2大车，3超大车，4中型车' },
                        { info1: 'similarPlates', info2: '是', info3: 'String', info4: '模糊匹配车牌号（逗号分隔）' },
                        { info1: 'isDeleted', info2: '是', info3: 'boolean', info4: '是否逻辑删除，0未删除，1删除' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getCarOwnerInfo.vue